// see:
// https://github.com/module-federation/module-federation-examples/tree/master/dynamic-system-host
// https://webpack.js.org/plugins/module-federation-plugin
// https://webpack.js.org/concepts/module-federation/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getOrLoadRemote } from './getOrLoadRemote';
/**
 * This does two things. First it makes sure the URL is loaded and available.
 * Then it will extract a `module` out of it and returns it.
 */
export function loadComponent(
/**
 * This should be the same as the 'name' property that is set in the client
 * ModuleFederation plugin.
 */
remote, 
/**
 * This should match one of the keys in the `exposes` map that is defined in
 * the clients ModuleFederation plugin.
 */
module, 
/** The URL of the remoteEntry.js file to load */
url) {
    return () => __awaiter(this, void 0, void 0, function* () {
        yield getOrLoadRemote(remote, url);
        const container = global[remote];
        const factory = yield container.get(module);
        const Module = factory();
        return Module;
    });
}
